import { render, staticRenderFns } from "./initPage.vue?vue&type=template&id=56f9762c&scoped=true"
import script from "./initPage.vue?vue&type=script&lang=js"
export * from "./initPage.vue?vue&type=script&lang=js"
import style0 from "./initPage.vue?vue&type=style&index=0&id=56f9762c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f9762c",
  null
  
)

export default component.exports